import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

import { IconButton } from '~/components/IconButton';
import { useAppDispatch, useAppSelector } from '~/application/hooks';
import { selectIsDrawerOpen, setDrawerOpen } from '../../slice';

export const MainDrawerToggle = () => {
    const dispatch = useAppDispatch();
    const drawerOpen = useAppSelector(selectIsDrawerOpen);

    return (
        <IconButton
            color="secondary"
            variant="light"
            onClick={() => dispatch(setDrawerOpen(!drawerOpen))}
            sx={{
                ml: { sx: 0, lg: -2 },
                color: 'text.primary',
                bgcolor: drawerOpen ? 'transparent' : 'grey.100',
            }}
        >
            {drawerOpen ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </IconButton>
    );
};
